<template>
  <DefaultHeader currentPage="home" />
  <main>
    <section>
      <ImageWidget />
    </section>

    <section>
      <AboutMeWidget />
    </section>

    <section>
      <ExpertiseWidget />
    </section>

    <section>
      <ExperienceWidget />
    </section>

    <section>
      <SkillsWidget />
    </section>

    <section>
      <EducationWidget />
    </section>

    <section>
      <EventsWidget />
    </section>
  </main>

  <DefaultFooter />
</template>

<script>
import DefaultHeader from '@/components/headers/DefaultHeader.vue'
import ImageWidget from '@/components/HomePage/ImageWidget.vue'
import AboutMeWidget from '@/components/HomePage/AboutMeWidget.vue'
import ExpertiseWidget from '@/components/HomePage/ExpertiseWidget.vue'
import ExperienceWidget from '@/components/HomePage/ExperienceWidget.vue'
import SkillsWidget from '@/components/HomePage/SkillsWidget.vue'
import EducationWidget from '@/components/HomePage/EducationWidget.vue'
import EventsWidget from '@/components/HomePage/EventsWidget.vue'
import DefaultFooter from '@/components/footers/DefaultFooter.vue'

export default {
  components: {
    DefaultHeader,
    ImageWidget,
    AboutMeWidget,
    ExpertiseWidget,
    ExperienceWidget,
    SkillsWidget,
    EducationWidget,
    EventsWidget,
    DefaultFooter
  },
}
</script>
